import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { AnalyticsStore, ContextStore, ExperimentStore } from 'bernie-core';
import { ILocalization } from 'bernie-l10n';
import { PageData } from 'bernie-http';

import { MultiItemStore } from 'stores/multi-item-store';

import { MitStep } from 'models/multi-item/multi-item-types';

import { MultiItemProgressIndicator } from 'src/common/components/multi-item/progress-indicator';

export type MitHeaderProps = {
  currentStepName: MitStep;
  multiItem?: MultiItemStore;
  experiment?: ExperimentStore;
  context?: ContextStore;
  page?: PageData;
  analytics?: AnalyticsStore;
  l10n: ILocalization;
};

export const MitHeader: React.FunctionComponent<MitHeaderProps> = inject(
  'multiItem',
  'analytics'
)(
  observer(props => {
    const { multiItem, analytics } = props;
    if (multiItem && multiItem.isPackageShoppingPath()) {
      const multiItemSessionId = multiItem.multiItemSessionId;

      return <MultiItemProgressIndicator {...{ multiItemSessionId, analytics }} />;
    }

    return null;
  })
);

MitHeader.displayName = 'MitHeader';
